import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../BasePanelPage";
import {PaymentMethodStore} from "../../../../../client/state/PaymentMethodStore";
import {Flow} from "../../../initializeFlows";
import {LoadingSpinner} from "../../../../ui/LoadingSpinner";
import {DonateComponent} from "./components/DonateComponent";
import {MerchantButton} from "../../../../common/MerchantButton";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {INLINE_DONATION_URLS, PAYMENT_DETAILS_PANEL_URL} from "../../../PanelConstants";
import {Messages} from "../../../../Messages";
import {UsingCardComponent} from "../payment-method/components/UsingCardComponent";
import {PayWithAddedCardComponent} from "../payment-method/components/PayWithAddedCardComponent";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {AddNewOrLoadCardComponent} from "../payment-method/components/AddNewOrLoadCardComponent";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {Controller} from "../../../Controller";


export class PaymentAndDonationPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    panelPage = this.themeProps.INLINE_DONATE_FLOW_PAGE;

    @styleRule
    cardComponent = {
        marginBottom: 24,
    };
}

@registerStyle(PaymentAndDonationPanelStyle)
export class PaymentAndDonationPanel extends BasePanelPage {
    forceAddCard = false;
    allowRedraw = true;

    isButtonDisabled() {
        return !Flow.donation.isValid() || !this.cardComponent?.isValid();
    }

    donate() {
        this.allowRedraw = false;
        LoadingSpinner.show();

        this.cardComponent.getPaymentMethodId(Controller.paymentMethod.getScope(), paymentMethodId => {
            if (iFrameMerchantService.isCDSPaymentMethod()) {
                Controller.paymentMethod.update({selectedPaymentMethod: paymentMethodId});
            } else {
                Controller.paymentMethod.update({selectedPaymentMethod: PaymentMethodStore.get(paymentMethodId)});
            }
            Flow.donation.donateInlineFlowDonate();
        }, () => {
            LoadingSpinner.hide();
            this.allowRedraw = true;
            this.redraw();
        });
    }

    redraw() {
        if (this.allowRedraw) {
            super.redraw();
        }
    }

    render() {
        const {styleSheet} = this;
        if (!Controller.paymentMethod.selectedPaymentMethod) {
            Controller.paymentMethod.selectedPaymentMethod = PaymentMethodStore.getPrimary() || PaymentMethodStore.getAvailablePaymentMethods()[0];
            Controller.paymentMethod.initialPaymentMethod = Controller.paymentMethod.selectedPaymentMethod;
        }
        let cardSection;
        if (!Controller.paymentMethod.selectedPaymentMethod && iFrameUserDataService.getExtraPaymentMethodCount() > 0 && !this.forceAddCard && !iFrameMerchantService.isCDSPaymentMethod()) {
            cardSection = <AddNewOrLoadCardComponent onAddCard={() => {
                this.forceAddCard = true;
                this.redraw();
            }} />;
        } else {
            const CardSectionClass = Controller.paymentMethod.selectedPaymentMethod && !iFrameMerchantService.isCDSPaymentMethod()
                ? UsingCardComponent : PayWithAddedCardComponent;
            cardSection = <CardSectionClass card={Controller.paymentMethod.selectedPaymentMethod} changeCardMessage={Messages.edit}
                                            onChange={() => this.redraw()} ref="cardComponent"
                                            onChangeCard={() => {
                                                Controller.paymentMethod.initialPaymentMethod = Controller.paymentMethod.selectedPaymentMethod;
                                                Router.changeURL(PAYMENT_DETAILS_PANEL_URL);
                                            }}
                                            className={styleSheet.cardComponent} />;
        }

        return [
            cardSection,
            <DonateComponent ref="donateComponent" onChange={() => this.redraw()}/>,
            <MerchantButton disabled={this.isButtonDisabled()} onClick={() => this.donate()}
                            className={styleSheet.button}>
                {
                    // We use the string because of a weird safari bug where the first click isn't perceived.
                    Flow.donation.getDonateComponentButtonLabel().toString()
                }
            </MerchantButton>,
        ]
    }

    onMount() {
        super.onMount();
        this.redraw(); // This is for the first rendering where the button doesn't have a label.
        this.attachChangeListener(PaymentMethodStore, () => this.redraw());
    }
}
